<script setup>
// Astra DS · Chip — **envoltorio del botón del sistema.**
//
// 🔴 **El estilo ya no vive aquí: vive en `ButtonDs`**, que desde el 18.09.26 es
// el master del sistema. Esto queda como traductor de la API que ya usan ocho
// ficheros —`variant`, `showDot`, `as`— a las propiedades del master, para que
// ninguna página tenga que cambiar el día del cambio.
//
// Figma: Chip 343:106. Su caja —8/16, 12 px, mayúsculas— es el tamaño `sm` del
// master, así que aquí no se repite ninguna medida.
//
// Conserva la clase `chip` porque varias páginas afinan su propio chip desde
// fuera (`:deep(.chip)`): quitarla obligaría a tocarlas todas hoy, que es justo
// lo que este cambio viene a evitar.
import { computed } from "vue";
import ButtonDs from "./ButtonDs.vue";

const props = defineProps({
  label: { type: String, required: true },
  variant: {
    type: String,
    default: "outlined",
    // `lanzamiento` (19.10.26): NUEVO LANZAMIENTO, en azul y a talla `micro`
    // —`mono/micro`, 7 · 13—, que es la caja del nodo `2505:139`.
    validator: (v) => ["outlined", "solid-accent", "solid-inverse", "lanzamiento"].includes(v),
  },
  showDot: { type: Boolean, default: false },
  href: { type: String, default: "" },
  to: { type: [String, Object], default: null },
  as: {
    type: String,
    default: "span",
    validator: (v) => ["span", "button"].includes(v),
  },
  // Sobre qué se apoya. Ver `ButtonDs`: lo pide la superficie, no la pantalla.
  surface: {
    type: String,
    default: "canvas",
    validator: (v) => ["canvas", "imagen"].includes(v),
  },
});

const forma = computed(
  () =>
    ({
      outlined: "ghost",
      "solid-accent": "accent",
      "solid-inverse": "inverse",
      lanzamiento: "release",
    })[props.variant],
);

const talla = computed(() => (props.variant === "lanzamiento" ? "micro" : "sm"));
</script>

<template>
  <ButtonDs
    class="chip"
    :class="`chip--${variant}`"
    :label="label"
    :variant="forma"
    :size="talla"
    :dot="showDot"
    :surface="surface"
    :as="as"
    :href="href"
    :to="to"
  />
</template>
